export const interfaceDataTypes = {
    BOOLEAN: 'BOOLEAN',
    STRING: 'STRING',
    DECIMAL: 'DECIMAL',
    INTEGER: 'INTEGER',
    NUMERIC: 'NUMERIC',
    METADATA: 'METADATA'
};

export const interfaceHistoryConfig = {
    NO_HISTORY: "NO_HISTORY",
    ALL_VALUES: "ALL_VALUES",
    DIFFERENT_VALUES: "DIFFERENT_VALUES"
};

export const interfaceType = {
    IN: "IN",
    OUT: "OUT",
    IN_OUT: "IN_OUT"
};